// src/pages/Appli/AppliAdmin/VisitorCenter/hooks/useVisitorCallbacks.js

import {
  useCallback,
  useEffect,
  useState,
} from "react";

import {
  deleteVisitorCallbackRequest,
  getVisitorCallbackRequestById,
  getVisitorCallbackRequests,
  updateVisitorCallbackRequest,
} from "./../../../../../services/visitorCallbackServices";

export default function useVisitorCallbacks({
  enabled = false,
} = {}) {
  const [rows, setRows] = useState([]);
  const [selectedRequest, setSelectedRequest] =
    useState(null);

  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] =
    useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setErrorMessage("");

      const response =
        await getVisitorCallbackRequests({
          page,
          limit: 30,
          q,
          status,
        });

      setRows(response?.data || []);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.error ||
          "Impossible de récupérer les demandes de rappel.",
      );
    } finally {
      setLoading(false);
    }
  }, [page, q, status]);

  const selectRequest = useCallback(async (requestId) => {
    if (!requestId) {
      setSelectedRequest(null);
      return;
    }

    try {
      setDetailsLoading(true);

      const response =
        await getVisitorCallbackRequestById(
          requestId,
        );

      setSelectedRequest(response?.data || null);
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.error ||
          "Impossible de charger cette demande.",
      );
    } finally {
      setDetailsLoading(false);
    }
  }, []);

  const changeStatus = useCallback(
    async (requestId, nextStatus) => {
      try {
        await updateVisitorCallbackRequest(requestId, {
          status: nextStatus,
        });

        await refresh();

        if (selectedRequest?.id === requestId) {
          await selectRequest(requestId);
        }
      } catch (error) {
        setErrorMessage(
          error?.response?.data?.error ||
            "Impossible de modifier cette demande.",
        );
      }
    },
    [refresh, selectRequest, selectedRequest?.id],
  );

  const removeRequest = useCallback(
    async (requestId) => {
      try {
        await deleteVisitorCallbackRequest(requestId);

        if (selectedRequest?.id === requestId) {
          setSelectedRequest(null);
        }

        await refresh();
      } catch (error) {
        setErrorMessage(
          error?.response?.data?.error ||
            "Impossible de supprimer cette demande.",
        );
      }
    },
    [refresh, selectedRequest?.id],
  );

  useEffect(() => {
    if (!enabled) return;

    refresh();
  }, [enabled, refresh]);

  return {
    rows,
    selectedRequest,

    q,
    status,

    page,
    totalPages,

    loading,
    detailsLoading,
    errorMessage,

    setQ,
    setStatus,
    setPage,

    refresh,
    selectRequest,
    changeStatus,
    removeRequest,
  };
}